import type { Agency } from "@features/user"
import { FormatCurrency } from "components/Currency"
import { forwardRef } from "react"
import { isFirefox } from "react-device-detect"
import type { Offer } from "../../offersList/offersListTypes"
import FooterGea from "./FooterGea"

import styles from "./OffersGeabrasil.module.css"

interface OffersGeabrasilProps {
  offer: Offer
  agency?: Agency
}

const OffersGeabrasil = forwardRef<HTMLDivElement, OffersGeabrasilProps>(
  ({ offer, agency }, ref) => {
    const {
      AccommodationName,
      OfferTitle,
      Description,
      LeadInPrice,
      PriceType,
      ImageURL,
      WhatsIncluded,
      Nights,
    } = offer

    const agencyColor = agency?.color || "#2FAB67"

    return (
      <div
        ref={ref}
        className="p-8 bg-white"
        style={{ height: isFirefox ? "1050px" : "1120px", width: "100%" }}
      >
        <div
          className="bg-white h-full"
          style={{ position: "relative", fontFamily: "Helvetica" }}
        >
          <div style={{ background: agencyColor }} className={styles.Title}>
            {OfferTitle}
          </div>
          <div
            className={styles.Capa}
            style={{
              backgroundSize: "cover",
              height: "380px",
              backgroundImage: `url(${ImageURL || "https://placehold.co/1080x400/jpg?text=Imagem+Indisponível"})`,
            }}
          />

          <div className={styles.Hotel}>{AccommodationName}</div>

          <div className="flex">
            <div className="flex-40 w-2/5 pr-10">
              <div className={styles.Noites}>
                {Nights && `${Nights} Noites`}
              </div>
              <div className={styles.Description}>{Description}</div>
            </div>
            <div className="flex-60 w-3/5">
              <div className="flex justify-center gap-x-2 pt-2">
                <div className="flex-60 w-1/8">
                  <div className={styles.Desde}>{PriceType}</div>
                </div>
                <div className="flex-40 w-7/8">
                  <div className={styles.Price} style={{ color: agencyColor }}>
                    <FormatCurrency value={LeadInPrice} />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div id={styles.Footer}>
            <div className={styles.Incluido}>{WhatsIncluded}</div>
            <hr
              style={{
                margin: "20px 0px",
                border: "1px solid #979797",
                opacity: ".50",
              }}
            />
            {agency && <FooterGea agencyLabel="Cadastur" agency={agency} />}
          </div>
          <div className="clearfix" />
        </div>
      </div>
    )
  },
)

export default OffersGeabrasil
